import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { LOGOUT_ROUTE } from '@futrli/auth/core/constants';
import { getWorkspaceListingUrl, getWorkspaceUrl } from '@futrli/predict-next/workspaces/utils/route-utils';
import { matchSettingsPath, storeCurrentLocation } from '@futrli/shared-services';

import { EXIT_SETTINGS_KEY } from '../../../../../../skeleton/src/core/constants';
import { SettingsList } from '../settings-list/settings-list';

interface Props {
  workspaceId: string;
  handleSettingsClick: () => void;
  hasMembersPermission: boolean;
}

export const SettingsMenu = ({ workspaceId, hasMembersPermission, handleSettingsClick }: Props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const openSettings = (url: string) => {
    if (!matchSettingsPath(location.pathname)) {
      storeCurrentLocation(EXIT_SETTINGS_KEY);
    }
    navigate(url);
  };

  return (
    <SettingsList
      hasMembersPermission={hasMembersPermission}
      handleSettingsClick={handleSettingsClick}
      handleOrganisationsClick={() => openSettings(getWorkspaceListingUrl(workspaceId))}
      handleUsersClick={() => openSettings(getWorkspaceUrl(workspaceId, 'users'))}
      handleLogoutClick={async event => {
        event.preventDefault();
        navigate(LOGOUT_ROUTE);
      }}
    />
  );
};
